import actionTypes from './actionTypes';

const INITIAL_STATE = {
  loading: false,
  failed: false,
  error: false,
  message: null,

  paymentDetailsLoading: false,
  paymentDetailsFailed: false,
  paymentDetailsError: false,
  paymentDetailsMessage: null,

  getPaymentsExcelFileLoading: false,
  getPaymentsExcelFileFailed: false,
  getPaymentsExcelFileError: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PAYMENTS_LOADING:
      return {
        ...state,
        loading: true,
        failed: false,
        error: false,
        message: null
      };

    case actionTypes.FETCH_PAYMENTS_SUCCESS:
      return {
        ...state,
        payments: action.payload,
        paymentsList: action.payload.payments,
        loading: false,
        failed: false,
        error: false,
        message: null
      };
    case actionTypes.FETCH_PAYMENTS_FAILED:
      return {
        ...state,
        loading: false,
        failed: true,
        error: false,
        message
      };
    case actionTypes.FETCH_PAYMENTS_REJECT:
      return {
        ...state,
        loading: false,
        failed: false,
        error: true,
        message: null
      };
    case actionTypes.FETCH_PAYMENTDETAILS_LOADING:
      return {
        ...state,
        paymentDetailsLoading: true,
        paymentDetailsFailed: false,
        paymentDetailsError: false,
        paymentDetailsMessage: ''
      };

    case actionTypes.FETCH_PAYMENTDETAILS_SUCCESS:
      return {
        ...state,
        paymentDetails: { ...action.payload },
        paymentDetailsLoading: false,
        paymentDetailsFailed: false,
        paymentDetailsError: false,
        paymentDetailsMessage: null
      };
    case actionTypes.FETCH_PAYMENTDETAILS_FAILED: {
      let { message } = action.payload;
      return {
        ...state,
        paymentDetailsLoading: false,
        paymentDetailsFailed: true,
        paymentDetailsError: false,
        paymentDetailsMessage: message
      };
    }
    case actionTypes.FETCH_PAYMENTDETAILS_REJECT: {
      return {
        ...state,
        paymentDetailsLoading: false,
        paymentDetailsFailed: false,
        paymentDetailsError: true,
        paymentDetailsMessage: ''
      };
    }

    case actionTypes.GET_PAYMENTS_EXCEL_FILE_LOADING: {
      return {
        ...state,
        getPaymentsExcelFileLoading: true,
        getPaymentsExcelFileFailed: false,
        getPaymentsExcelFileError: false
      };
    }
    case actionTypes.GET_PAYMENTS_EXCEL_FILE_SUCCESS: {
      return {
        ...state,
        getPaymentsExcelFileLoading: false,
        getPaymentsExcelFileFailed: false,
        getPaymentsExcelFileError: false
      };
    }
    case actionTypes.GET_PAYMENTS_EXCEL_FILE_FAILED: {
      return {
        ...state,
        getPaymentsExcelFileLoading: false,
        getPaymentsExcelFileFailed: true,
        getPaymentsExcelFileError: false
      };
    }
    case actionTypes.GET_PAYMENTS_EXCEL_FILE_REJECT: {
      return {
        ...state,
        getPaymentsExcelFileLoading: false,
        getPaymentsExcelFileFailed: false,
        getPaymentsExcelFileError: true
      };
    }

    default:
      return state;
  }
};
